import { FilterType } from '../../../../interfaces/Filter.interfaces';
import { SlideConfirmModal } from '../../modal/slide/SlideConfirmModal';
import { FilterController } from './components/FilterController/FilterController';

interface FilterSlideModalProps {
  isShow: boolean;
  closeModal: () => void;
  filterType: FilterType;
}

export const FilterSlideModal = ({ isShow, closeModal, filterType }: FilterSlideModalProps) => {
  return (
    <SlideConfirmModal
      isShow={isShow}
      height={700}
      element={<FilterController closeModal={closeModal} filterType={filterType} />}
      closeButton={{ handleClick: closeModal }}
      isShowCloseButton
      gap={'0px'}
      padding={'0px'}
    />
  );
};
